// src/FAQ.js

import React, { useState, useRef, useEffect } from 'react';
import './FAQ.css';
import faqData from './faqData'; // Import the new data file

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const answerRefs = useRef([]);

    // We now use the imported data directly
    const questions = faqData;

    const toggleAnswer = (index) => {
        setActiveIndex(prevIndex => (prevIndex === index ? null : index));
    };

    useEffect(() => {
        answerRefs.current.forEach((ref, index) => {
            if (ref) {
                if (activeIndex === index) {
                    ref.style.height = `${ref.scrollHeight}px`;
                } else {
                    ref.style.height = '0px';
                }
            }
        });
    }, [activeIndex]);

    return (
        <div className="faq-container" id="FAQ">
            <h1 className="faq-title">Frequently Asked Questions [FAQs]</h1>
            <div className="faq-list">
                {questions.map((item, index) => (
                    <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
                        <div
                            className="faq-question"
                            onClick={() => toggleAnswer(index)}
                        >
                            {item.question}
                            <span className="faq-triangle-icon">&#9658;</span>
                        </div>
                        <div
                            ref={el => answerRefs.current[index] = el}
                            className="faq-answer"
                        >
                            <div className="faq-answer-inner">
                                {item.answer}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQ;